import { 
	AuthService, 
	ProgressService 
} from 'phoenix/services';
const template = require('./login-reset-password.template');	

/**
 * @ngdoc directive
 * @name phoenix.directive:pxLoginResetPassword
 * @module phoenix
 * @restrict E
 * @description
 *
 * `pxLoginResetPassword` a view component of `pxLogin`
 *
 * @param {string=} errorMessage This should typically be the application's name.
 * If no title is supplied the control's header will not be displayed
 */
export function LoginResetPasswordDirective() {
	return {
		restrict: 'E',
		controller: LoginResetPasswordController,
		controllerAs: 'vm',
		bindToController: true,
		template,
		scope: {
			errorMessage: '=?'
		},
		link: function (scope, element, attrs) {

		}
	};
}
function LoginResetPasswordController(
	$stateParams, 
	$state, 
	pxAuthService:AuthService, 
	pxProgressService:ProgressService, 
	gettextCatalog:ng.gettext.gettextCatalog
) {
	var vm = this;
	var authToken = $stateParams.auth;
	vm.errorMessage = '';
	vm.submitting = false;
	vm.resetPassword = resetPassword;
	vm.gotoLogin = gotoLogin;

	function resetPassword() {
		if (vm.resetPasswordForm.$valid) {
			if (vm.newPassword !== vm.confirmPassword) {
				vm.errorMessage = gettextCatalog.getString('Passwords don\'t match');
			}
			else {
				pxProgressService.text = gettextCatalog.getString('Updating Password');
				isSubmitting(true);
				pxAuthService
					.resetPassword(authToken, vm.newPassword)
					.then(function (result) {
						if (result.InvalidPassword) {
							vm.errorMessage = result.Error;
						}
						else {
							$state.go('login');
						}
					})
					.catch(function (response) {
						vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred.');
						switch(response.status){
							case 401:
								$state.go('login', {
                					errorMessage: gettextCatalog.getString('The password reset link has expired.')
           						});
								break;
						}
					})
					.finally(function () {
						isSubmitting(false);
					});
			}
		}
	}

	function gotoLogin() {
		$state.go('login');
	}

	function isSubmitting(submitting) {
		if (submitting) {
			pxProgressService.backdrop = submitting;
		}
		pxProgressService.visible = submitting;
		vm.submitting = submitting;
	}
}

LoginResetPasswordController.$inject = [
	'$stateParams',
	'$state',
	'pxAuthService',
	'pxProgressService',
	'gettextCatalog'
];




// WEBPACK FOOTER //
// ./src/phoenix/components/login/login-reset-password.component.ts